<template>
    <div class="row passenger_list" v-if="show_items">

        <div v-if="loading_items" class="col-md-12 center_item"><i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}...</div>
        <div class="col-sm-12" v-else>


            <div class="table-responsive" v-if="items.length">
                <table class="table table-striped table-hover mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Пассажир</th>
                            <th scope="col">{{i18n('Routes')}}</th>
                            <th scope="col">Время</th>
                            <th scope="col">Посмотреть билет</th>
                        </tr>
                    </thead>

                    <tbody v-for="item in items">
                        <tr>
                            <td>{{item.full_name}}</td>
                            <td>{{item.trip.time}}</td>
                            <td>{{item.trip.route.name}}</td>
                            <td>
                                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light" @click="getTicketByPassenger(item.id)">{{item.id}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row" v-else>
                <label class="col-xl-4 col-lg-3 col-form-label fs-12 pt-12"><h2>{{error_message}}</h2></label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ListBySurname",
        props: {
            passanger_fullname: {
                type: String,
            },
            search: {
                type: Boolean,
                default: false
            },
            getTicketByPassenger: {
                default: () => {}
            }
        },
        data(){
            return {
                items: [{
                    full_name: null,
                    ticket_id: null,
                    trip: {
                        time: null,
                        route: {
                            name: null,
                            number: null
                        }
                    }
                }],
                show_items: false,
                loading_items: false,
                error_message: null,
            }
        },
        methods: {
            getPassengerItems(){
                if(this.passanger_fullname){

                    this.show_items = true
                    this.loading_items = true

                    this.$api.post("return-ticket.get-list-passenger",
                        {
                            full_name: this.passanger_fullname
                        })
                        .then(data => {
                            this.items = data

                            if(data.length == 0){
                                this.error_message = "Пассажир не найден"
                            }

                        }).finally(() => {
                            this.loading_items = false
                    })
                }else{
                    this.show_items = false
                    this.loading_items = false
                }
            }
        },
        watch: {
            search(new_value, old_value){
                if(new_value){
                    this.getPassengerItems()
                }
            }
        }
    }
</script>

<style scoped>
    .center_item{
        text-align: center
    }
    .passenger_list{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #eaedf1;
    }
</style>